import { NotifierEmailModalForm } from "./NotifierEmailModalForm"

const NotifierEmailModalFormWrapper = ({
  selectedReport,
  setSelectedReport,
  openNotifierEmailModal,
  setOpenNotifierEmailModal,
}) => {

  if (selectedReport) {
    return (
      <NotifierEmailModalForm
        selectedReport={selectedReport}
        setSelectedReport={setSelectedReport}
        openNotifierEmailModal={openNotifierEmailModal}
        setOpenNotifierEmailModal={setOpenNotifierEmailModal}
      />
    );
  }
  return null;
};

export { NotifierEmailModalFormWrapper };
